import _styled from '@emotion/styled/base';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { SIZE_MAP } from './constants.js';
import { getMaxFontSize } from './utils.js';
import { border, text } from '@hubble/tokens/web';

const StyledAvatar = _styled(AvatarPrimitive.Root, {
  shouldForwardProp: prop => prop !== 'backgroundColor' && prop !== 'contentColor',
  target: "eoglunk0"
})(({
  size = 'md',
  theme,
  backgroundColor,
  contentColor
}) => `
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  user-select: none;
  border-radius: ${border.radius.full};
  height: ${SIZE_MAP[size]};
  min-height: ${SIZE_MAP[size]};
  width: ${SIZE_MAP[size]};
  min-width: ${SIZE_MAP[size]};
  background-color: ${backgroundColor ? backgroundColor : theme.colorScheme.iconBadge.background.default};
  color: ${contentColor ? contentColor : theme.colorScheme.iconBadge.content.default};

  font-size: ${getMaxFontSize(SIZE_MAP[size])};
  line-height: ${SIZE_MAP[size]};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
  }

  abbr {
    color: currentColor;
    font-size: inherit;
    line-height: inherit;
    font-weight: ${text.base.weight.semiBold};
    position: absolute;
    text-decoration: none;
  }
`);

export { StyledAvatar };
